import { Profile2User, Judge, Wallet, Data2 } from "iconsax-react";
import type { Icon } from "iconsax-react";

interface AccessRoleIconConfig {
  Icon: Icon;
  labelKey: string;
}

const ACCESS_ROLE_ICON_MAP: Record<string, AccessRoleIconConfig> = {
  hr: { Icon: Profile2User, labelKey: "roleAssignment.roles.hr" },
  lawyer: { Icon: Judge, labelKey: "roleAssignment.roles.lawyer" },
  accountant: { Icon: Wallet, labelKey: "roleAssignment.roles.accountant" },
  pm: { Icon: Data2, labelKey: "roleAssignment.roles.pm" },
};

export function getAccessRoleIconConfig(role: string): AccessRoleIconConfig | null {
  return ACCESS_ROLE_ICON_MAP[role] ?? null;
}

export { ACCESS_ROLE_ICON_MAP };
export type { AccessRoleIconConfig };
